import { Seo, Breadcrumbs, breadcrumbSchema } from "@/components/Seo";
import { Reveal, SectionTag, Marquee } from "@/components/Motion";
import { FinalCta } from "@/components/Cta";

const CRUMBS = [{ name: "首页", path: "/" }, { name: "关于我们", path: "/about" }];

const FACTS = [
  { q: "TKShopMY 是什么？", a: "TKShopMY 是一家服务马来西亚市场的独立电商运营服务团队，主要为本地商家提供 TikTok Shop 开店咨询、店铺运营、商品优化、内容方向及卖家支持服务。" },
  { q: "TKShopMY 做什么？", a: "我们提供 TikTok Shop 开店咨询、店铺代运营、商品优化、内容方向、活动与促销规划，以及卖家一对一支持。" },
  { q: "TKShopMY 服务哪些客户？", a: "主要服务马来西亚 SME、本地商家、品牌方、新卖家，以及已经经营 TikTok Shop、希望改善店铺表现的商家。" },
  { q: "TKShopMY 在哪里服务？", a: "服务全马来西亚 —— 包括吉隆坡、雪兰莪、柔佛、槟城和马六甲 —— 通过在线咨询和预约沟通远程进行。" },
  { q: "TKShopMY 是 TikTok 官方吗？", a: "不是。TKShopMY 是独立电商服务商，并非 TikTok 或 TikTok Shop 官方机构、官方代理或关联公司。" },
];

export default function About() {
  return (
    <>
      <Seo
        title="关于 TKShopMY — 马来西亚电商运营团队"
        description="TKShopMY 是一家服务马来西亚市场的独立电商运营服务团队，帮助本地商家处理 TikTok Shop 开店咨询、店铺运营、商品优化和内容方向。"
        path="/about"
        schemas={[breadcrumbSchema(CRUMBS)]}
      />
      <section className="pt-28 md:pt-40 pb-16 md:pb-24" data-testid="about-hero">
        <div className="mx-auto max-w-6xl px-5 md:px-8">
          <Breadcrumbs items={CRUMBS} />
          <Reveal>
            <SectionTag>关于 TKShopMY</SectionTag>
            <h1 className="max-w-3xl font-display text-4xl font-medium leading-[1.15] text-balance sm:text-5xl lg:text-6xl">
              认真帮你把店铺当生意经营的马来西亚团队
            </h1>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-ink/65 md:text-lg">
              TKShopMY 的起点很简单：很多马来西亚商家有好产品，
              但很少有时间或内部人手把网店认真经营好。我们就是为了补这个缺口 ——
              实际、坦白，不夸大。
            </p>
          </Reveal>
        </div>
      </section>

      <Marquee items={["专注马来西亚市场", "实际解决问题", "一对一沟通", "长期经营方向", "服务内容透明"]} />

      <section className="py-16 md:py-24">
        <div className="mx-auto max-w-4xl px-5 md:px-8">
          <Reveal>
            <SectionTag>事实说清楚</SectionTag>
            <h2 className="font-display text-3xl font-medium sm:text-4xl">一眼看懂 TKShopMY</h2>
          </Reveal>
          <div className="mt-10 space-y-4">
            {FACTS.map((f, i) => (
              <Reveal key={f.q} delay={i * 0.06}>
                <div className="rounded-2xl border border-ink/10 bg-white p-7" data-testid={`about-fact-${i}`}>
                  <h3 className="font-display text-xl font-semibold text-forest">{f.q}</h3>
                  <p className="mt-2.5 text-sm leading-relaxed text-ink/65 md:text-base">{f.a}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.2}>
            <div className="mt-12 rounded-2xl bg-sand p-8">
              <h2 className="font-display text-2xl font-semibold">我们的合作方式</h2>
              <p className="mt-4 text-base leading-relaxed text-ink/70">
                我们不会把固定配套卖给每个人。每次合作都从 WhatsApp 咨询开始 —— 先了解你的产品和情况。
                如果我们不适合你，我们会直接说，并告诉你更合适的方向。
                如果适合，开始前你会清楚知道服务包括什么、不包括什么。
                TKShopMY 也提供不同合作模式咨询，包括一件代发及无需自行囤货的方式。
              </p>
            </div>
          </Reveal>
        </div>
      </section>

      <FinalCta />
    </>
  );
}
